import type { ComboboxOptionsType, ComboboxRootPropsInterface } from '../types/combobox-root.types';
import { getFilteredOptionsCount } from './get-filtered-options-count';

interface GetComboboxLiveAnnouncementOptionsInterface {
  autoCompleteBehavior: NonNullable<ComboboxRootPropsInterface<string>['autoCompleteBehavior']>;
  filteredOptions: ComboboxOptionsType;
  isDirty: boolean;
  loading: boolean;
  open: boolean | undefined;
}

/**
 * Gets the autocomplete status announced by the combobox live region.
 *
 * @param options - Current combobox state used to derive the announcement
 * @returns The live-region announcement, or an empty string when announcements are inactive
 */
export const getComboboxLiveAnnouncement = ({
  autoCompleteBehavior,
  filteredOptions,
  isDirty,
  loading,
  open,
}: GetComboboxLiveAnnouncementOptionsInterface): string => {
  if (!open || !isDirty || autoCompleteBehavior === 'none') {
    return '';
  }

  if (loading) {
    return 'Loading autocomplete results.';
  }

  const count = getFilteredOptionsCount(filteredOptions);

  return `${count || 'No'} autocomplete result${count === 1 ? '' : 's'} available.`;
};
